<template>
  <div class="row service_builder_block">
    <div class="col-md-11 col-sm-12 col-lg-11 col-xs-12 p-0">
      <div class="col-xs-12 btn-display">
        <button type="button" class="btn emergo-green-button" :disabled="notValidUser" @click="payForService(true)">
          <span>Purchase</span>
        </button>
      </div>
    </div>
    <div class="col-md-12 col-sm-12 col-lg-12 col-xs-12" v-for="(content, index) in blocksdata.blocks" :key="index" :id="index + '_smart_builder_block'">
      <div class="col-md-11 col-sm-12 col-lg-11 col-xs-12 block_smart desc-content">
        <div class="col-xs-12 col-sm-8 p-0 smart-builder-subheader text-color-blue" v-html="content.header"></div>
        <div class="col-xs-12 col-sm-4 smart-builder-pricing text-color-blue" v-if="content.pricing">
          <span v-html="content.pricing"></span>
        </div>
        <div class="col-md-12 col-sm-12 col-lg-12 col-xs-12 pl-3">
          <div class="row m-0" v-for="i in Math.ceil(content.points.length / 2)" :key="i">
            <div class="col-xs-12 col-sm-6 col-md-6" v-for="(point, index_V) in content.points.slice((i - 1) * 2, i * 2)" :key="index_V">
              <span class="list-item" v-html="point"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['blocksdata', 'id', 'header', 'notValidUser'],
  data() {
    return {};
  },
  methods: {
    payForService(otherPC) {
      this.$parent.payForService(otherPC);
    },
  },
};
</script>
<style scoped>
.m-0 {
  margin: 0;
}
.ml-10 {
  margin-left: 10px;
}
.list-item {
  display: list-item;
}
::v-deep .list-item sup {
  top: -0.1em;
  font-size: 100%;
}
.pl-3 {
  padding-left: 3%;
}
li {
  padding-left: 0px;
}
.mr-bt-20 {
  margin-bottom: 20px;
}
.block_smart {
  border-top: 0.5px solid #828282;
  margin: 10px 20px 0px 20px;
  padding-top: 18px;
}
.smart-builder-subheader {
  font-weight: normal;
  font-size: 24px;
  line-height: 33px;
  margin: 0 0 6px;
}
.smart-builder-pricing {
  display: flex;
  justify-content: flex-end;
  font-size: 18px;
  line-height: 33px;
  margin: 0 0 6px;
  padding-left: 0;
}
.service_builder_block {
  margin: 0px;
  padding: 20px 30px;
  background: rgba(103, 177, 226, 0.1);
}
.p-0 {
  padding: 0px;
}
.pr-0 {
  padding-right: 0px;
}
.p-35 {
  padding: 35px;
}
.text-color-white {
  color: #fff;
}
.desc-subheader {
  font-weight: 300;
  font-size: 26px;
  line-height: 33px;
  margin: 8px 0;
}
.desc-content p {
  font-weight: normal;
  font-size: 16px;
  line-height: 25px;
  color: rgba(0, 0, 0, 0.7);
}
.desc-content {
  font-size: 16px;
  font-weight: normal;
}
.text-color-blue {
  color: #00518a;
}
.emergo-green-button {
  line-height: 35px;
  border-radius: 25px;
  font-size: 25px;
  padding-left: 25px;
  padding-right: 25px;
  font-weight: normal;
}
.float-right {
  float: right;
}
.btn-display {
  display: flex;
  justify-content: flex-end;
}
.btn-display button {
  margin: 0 5px;
}
@media screen and (max-width: 767px) {
  .emergo-green-button {
    font-size: 18px;
    line-height: 21px;
  }
  .smart-builder-pricing {
    justify-content: flex-start;
    font-size: 16px;
  }
}
@media screen and (max-width: 480px) {
  .btn-display {
    justify-content: center;
    flex-direction: column;
  }
  .btn-display button {
    margin-bottom: 7px;
  }
  .block_smart {
    margin: 0;
    padding: 18px 0 0;
  }
}
</style>
